module.exports = __webpack_public_path__ + "img/go10.a342b51a.png";